export const PATH_USER_ACCOUNT = "/user-account";
export const PATH_USER_ACCOUNT_LANGUAGE = `${PATH_USER_ACCOUNT}/language`;
export const PATH_USER_ACCOUNT_PROFILE = `${PATH_USER_ACCOUNT}/profile`;

export const PATH_USER_ACCOUNT_ADMINISTRATION = "/user-account-administration";
export const PATH_USER_ACCOUNT_ADMINISTRATION_LANGUAGE = `${PATH_USER_ACCOUNT_ADMINISTRATION}/language`;
export const PATH_USER_ACCOUNT_ADMINISTRATION_PROFILE = `${PATH_USER_ACCOUNT_ADMINISTRATION}/profile`;

export const PATH_USER_MANAGEMENT = "/user-management";
export const PATH_USER_MANAGEMENT_GROUPS = `${PATH_USER_MANAGEMENT}/groups`;
export const PATH_USER_MANAGEMENT_GROUPS_CODE = `${PATH_USER_MANAGEMENT_GROUPS}/:code`;
export const PATH_USER_MANAGEMENT_USERS = `${PATH_USER_MANAGEMENT}/users`;
export const PATH_USER_MANAGEMENT_USERS_LOGIN = `${PATH_USER_MANAGEMENT_USERS}/:userLogin`;

export const GROUP_CODE_NEW = "new";
